// Author YuJiaBei
// Date 2021-01-05 08:33:12

class RepairPriority {
constructor({
        id = null,
        name = '',
        description = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.description = description;
}
}

function newEntity() {
return new RepairPriority();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.repair.repairPriority.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.repair.repairPriority.grid.description',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.repair.repairPriority.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.repair.repairPriority.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.repair.repairPriority.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {RepairPriority, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
